import { createStore } from "vuex";

export default createStore({
    state() {
        return {
            userId: "",
            requestId: "",
            convertedFileName: "",
            type: "",
            selectedActivityIds: [] // Global activity selections across process files
        }
    },
    mutations: {
        setUserId(state, userId) {
            state.userId = userId;
        },
        setRequestId(state, requestId) {
            state.requestId = requestId;
        },
        setConvertedFileName(state, convertedFileName) {
            state.convertedFileName = convertedFileName;
        },
        setType(state, type) {
            state.type = type;
        },
        addActivityId(state, activityId) {
            if (!state.selectedActivityIds.includes(activityId)) {
                state.selectedActivityIds.push(activityId);
            }
        },
        removeActivityId(state, activityId) {
            const index = state.selectedActivityIds.indexOf(activityId);
            if (index >= 0) {
                state.selectedActivityIds.splice(index, 1);
            }
        },
        clearSelectedActivities(state) {
            state.selectedActivityIds = [];
        }
    },
    getters: {
        getUserId(state) {
            return state.userId;
        },
        getRequestId(state) {
            return state.requestId;
        },
        getConvertedFileName(state) {
            return state.convertedFileName;
        },
        getType(state) {
            return state.type;
        },
        getSelectedActivityIds(state) {
            return state.selectedActivityIds;
        }
    }
});